import getSubCategories from "./getSubCategories";
import getItems from "./getItems";

const SvnFilter = ( element = false ) => {
    const FilterForm = document.getElementById('svn-filter');
    const FilterResultWrapper = document.getElementById('svn-filter-result');
    const btn = document.getElementById('load-more');
    let isLoadMore = false;

    const subCategoriesWrapper = document.querySelectorAll('.sub-category');
    const additionalFilter = document.querySelectorAll('.additional-filter');

    if( element ) {
        const name = element.getAttribute('name');

        if( name && name === 'category' ) {
            const currentSubCategoryWrapper = element.parentElement.nextElementSibling;
            subCategoriesWrapper.forEach( item => {
                item.classList.add('hidden');
                item.querySelectorAll('input').forEach( input => {
                    input.checked = false;
                })
            })

            if( additionalFilter ) {
                additionalFilter.forEach( item => {
                    item.classList.add('hidden');
                })
            }

            currentSubCategoryWrapper?.classList.remove('hidden');
        }

        if( name && name === 'sub_category' ) {
            const currentAdditionalFilter = element.parentElement.nextElementSibling;
            
            if( additionalFilter ) {
                additionalFilter.forEach( item => {
                    item.classList.add('hidden');
                    item.querySelectorAll('input').forEach( input => {
                        input.checked = false;
                    })
                })
            }

            currentAdditionalFilter?.classList.remove('hidden');
        }

        if( name && ( name === 'verlag' || name === 'alter_kinder' || name === 'alter_jugend' ) ) {
            const parentRadio = element.parentElement.parentElement.parentElement.previousElementSibling.querySelector('input');
            if( !parentRadio.checked ) {
                element.checked = false;
            }
        }

        if( name && name === 'load-more' ) {
            isLoadMore = true;
        }
    }
    
    const form = new FormData( FilterForm );
    getItems( form, FilterResultWrapper, btn, isLoadMore );

}

document.addEventListener('DOMContentLoaded', () => {

    // check if a category is selected
    /* const category = document.querySelectorAll('input[name="category"]');
    if( category ) {
        category.forEach( item => {
            if( item.checked ) {
                SvnFilter( item )
            }
        })
    } */

    // toggle
    const filterToggle = document.getElementById('svn-filter-toggle');
    const filter = document.getElementById('svn-filter');

    if( filterToggle && filter ) {
        filterToggle.addEventListener('click', () => {
            filterToggle.classList.toggle('active');
            filter.classList.toggle('active');
        });
    }

});

window.SvnFilter = SvnFilter;